/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';


export interface OperatorePraticaDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    authorities?: Set<AuthorityType>;
    comuni_ids?: Set<string>;
    account_enabled?: boolean;
    account_activated?: boolean;
    invito_in_attesa?: boolean;
    created_at?: string;
    updated_at?: string;
}

